export enum ExportDeckType {
    LAST_20 = 'LAST_20',
    LAST_40 = 'LAST_40',
    CUSTOM = 'CUSTOM',
}
